function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, Object, visibility) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          [`mp-drop-menu-${visibility}-${$attr(`direction`)}`]: true
        }, {
          'mp-drop-menu-body': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`with-caret`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "style": {
              left: $component.caretPos.left,
              right: $component.caretPos.right
            },
            "class": Object.assign({}, {
              'mp-drop-menu-caret-inverted': $attr(`direction`) === `up`
            }, {
              'mp-drop-menu-caret': true
            }),
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("slot"));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;